import React from 'react'

function TenderTextDKZ() {
  return (
    <embed src="\pdfs\EAT2.4.2_DK-LIG-Z-600_Chilled_beam_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextDKZ